import api from '@/api'

export default {

  submitApplication(data) {
    return api({
      url: '/user/coachRecruitmentSubmit',
      method: 'POST',
      data
    })
  },
  submitCourseApply(data) {
    return api({
      url: '/index/courseApplySubmit',
      method: 'POST',
      data
    })
  }
}
